import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Callback() {
  const navigate = useNavigate();
  const { handleCallback } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    async function processCallback() {
      try {
        const returnUrl = await handleCallback();
        navigate(returnUrl, { replace: true });
      } catch (err) {
        setError(err.message);
      }
    }

    processCallback();
  }, [handleCallback, navigate]);

  if (error) {
    return (
      <div className="callback-error">
        <div style={{
          background: 'var(--danger)',
          color: 'var(--status-contrast)',
          padding: 'var(--space-md) var(--space-lg)',
          borderRadius: 'var(--radius-md)',
        }}>
          {error}
        </div>
        <a href="/" className="btn btn-secondary">
          Return to home
        </a>
      </div>
    );
  }

  return (
    <div className="loading-overlay">
      <div style={{ textAlign: 'center' }}>
        <div className="loading-spinner" style={{ margin: '0 auto var(--space-lg)' }} />
        <p style={{ color: 'var(--text-muted)' }}>Completing sign in...</p>
      </div>
    </div>
  );
}
